const defaultPosition = {
    coords:{
        latitude: window.SIMPL.userDefaultLocation[0],
        longitude: window.SIMPL.userDefaultLocation[1]
    }
};

let _currentPosition;

export default function initMap(map,ControlPosition,mapServerType) {
    var cp = ControlPosition === "RIGHT_TOP" ? window.google.maps.ControlPosition.RIGHT_TOP : window.google.maps.ControlPosition.RIGHT_BOTTOM
    console.log(map);
    getCurrentPosition((pos) => {
        _currentPosition = pos;
        setBlueMarker(map, pos);
    });
    addYourLocationButton(map,cp);
    addSimplLabel(map,mapServerType);

    map.getStreetView().setOptions({ imageDateControl: true });
    map.setOptions({
        scrollwheel: true,
        draggable: true,
        fullscreenControl: false,
        streetViewControl: true,
        mapTypeControl: false,
        rotateControlOptions: {
			position: cp
		},
        zoomControlOptions :{
            position: cp
        },
        streetViewControlOptions: {
            position: cp
        }
    });
}

function setBlueMarker(map, position) {
    let latLng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude);
    map.panTo(latLng);

    let currentMarker = new window.google.maps.Marker({
        position: latLng,
        icon: {
            'path': window.google.maps.SymbolPath.CIRCLE,
            'fillColor': '#4285F4',
            'fillOpacity': 1,
            'scale': 12,
            'strokeColor': 'white',
            'strokeWeight': 4,
        }
    });
    currentMarker.setMap(map);
}

function getCurrentPosition(callback) {
    // 優先順
    // 1. geolocation
    // 2. userData の defaultLocation
    // 3. const の defaultPosition (Nihonbashi)
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (pos) {
            callback(pos);
        }, function () {
            callback(defaultPosition);
        });
    }
    else{
        callback(defaultPosition);
    }
}

function addSimplLabel(map,mapServerType) {

    let simplLabel = document.createElement("div");
    
    let controlText_gsi = document.createElement("div");
    controlText_gsi.id = "simplLabel_innerHTML_gsi";
    controlText_gsi.style.fontSize = "15px";
    controlText_gsi.style.fontWeight = "bold";
    controlText_gsi.style.display = mapServerType.startsWith("GSI")? "":"none";
    controlText_gsi.style.paddingRight = "5px";
    controlText_gsi.innerHTML =  '<a href="https://maps.gsi.go.jp/development/ichiran.html" target="_blank">国土地理院</a>';
    simplLabel.appendChild(controlText_gsi);

    let controlText = document.createElement("div");
    controlText.id = "simplLabel_innerHTML";
    controlText.style.color = "rgb(25,25,25)";
    controlText.style.fontFamily = "Roboto,Arial,sans-serif";
    controlText.style.fontSize = "12px";
    controlText.style.lineHeight = "18px";
    controlText.style.paddingLeft = "0px";
    controlText.style.paddingRight = "5px";
    controlText.innerHTML = new Date().getFullYear() + " - SIMPL&reg; (Smart Infrastructure Management PLatform)";
    simplLabel.appendChild(controlText);

    simplLabel.style.display = "flex";
    simplLabel.style.alignItems = "center";
    map.controls[window.google.maps.ControlPosition.BOTTOM_LEFT].push(simplLabel);  
}

function addYourLocationButton(map,cp) {
    let controlDiv = document.createElement('div');

    let contorlButton = document.createElement('button');
    contorlButton.style.backgroundColor = '#fff';
    contorlButton.style.border = 'none';
    contorlButton.style.outline = 'none';
    contorlButton.style.width = '40px';
    contorlButton.style.height = '40px';
    contorlButton.style.borderRadius = '2px';
    contorlButton.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
    contorlButton.style.cursor = 'pointer';
    contorlButton.style.marginRight = '10px';
    contorlButton.style.padding = '0';
    contorlButton.title = 'Your Location';
    controlDiv.appendChild(contorlButton);

    let contorlChildButton = document.createElement('div');
    contorlChildButton.style.margin = '10px';
    contorlChildButton.style.width = '20px';
    contorlChildButton.style.height = '20px';
    contorlChildButton.style.backgroundImage = 'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-cookieless-v2-2x.png)';
    contorlChildButton.style.backgroundSize = '180px 18px';
    contorlChildButton.style.backgroundPosition = '0px 0px';
    contorlChildButton.style.backgroundRepeat = 'no-repeat';
    //contorlChildButton.id = 'you_location_img';
    contorlButton.appendChild(contorlChildButton);

    controlDiv.addEventListener('click', function () {
        var latlng = new window.google.maps.LatLng(_currentPosition.coords.latitude, _currentPosition.coords.longitude);
        map.setCenter(latlng);
    });

    controlDiv.index = 1;
    map.controls[cp].push(controlDiv);
}



